import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import 'bootstrap/dist/css/bootstrap.css'; // В самом файле закомментировал строки, которые стилизуют стандартные элементы (button, h1, input, etc...)
import 'bootstrap-vue/dist/bootstrap-vue.css';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
Vue.use(BootstrapVue);	// Install BootstrapVue
Vue.use(IconsPlugin);		// Optionally install the BootstrapVue icon components plugin

import VPagination from 'vue-sliding-pagination';
import 'vue-sliding-pagination/dist/style/vue-sliding-pagination.css';
Vue.component('VPagination', VPagination);

// import VueToast from 'vue-toast-notification';
// Import one of available themes
// import 'vue-toast-notification/dist/theme-default.css';
// import 'vue-toast-notification/dist/theme-sugar.css';
// Vue.use(VueToast);

import VueMultiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
Vue.component('VueMultiselect', VueMultiselect);

import VSelect from '@/lib/VSelect';
Vue.component('VSelect', VSelect);

/* PRIMEVUE - компоненты*/
import '@/lib/primevue';

/* FONTAWESOME - иконки */
import '@/lib/fontawesome';

/* CUSTOM COMPONENTS */
import CustomModal from '@/lib/CustomModal';
Vue.component('CustomModal', CustomModal);

import CustomPSelect from '@/lib/customComponents/CustomPSelect';
Vue.component('CustomPSelect', CustomPSelect);

import CustomPInput from '@/lib/customComponents/CustomPInput';
Vue.component('CustomPInput', CustomPInput);

import CustomPCheckbox from '@/lib/customComponents/CustomPCheckbox';
Vue.component('CustomPCheckbox', CustomPCheckbox);

import CustomPModal from '@/lib/customComponents/CustomPModal';
Vue.component('CustomPModal', CustomPModal);

import CustomPConfirmation from '@/lib/customComponents/CustomPConfirmation';
Vue.component('CustomPConfirmation', CustomPConfirmation);


Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
